import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Table } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UseGroupingToolbarActionsReturn } from './types';

export function useGroupingToolbarActionsV8({
  table,
  layout,
}: {
  table: Table<unknown>;
  layout: 'table' | 'cards' | 'board';
}): UseGroupingToolbarActionsReturn {
  const { t } = useTranslation();

  const isSomeRowsExpanded = table.getIsSomeRowsExpanded();
  const isAllRowsExpanded = table.getIsAllRowsExpanded();
  const isGrouped = table.getState().grouping.length > 0;

  return useMemo(() => {
    if (!isGrouped || layout === 'board') return [];

    return [
      {
        actionKey: 'expand-all-grouped-row',
        mode: 'Add',
        sections: ['toolbar'],
        IconComponent: KeyboardArrowDownIcon,
        tooltip: t('GROUPING_TOOLBAR_ACTIONS.EXPAND_ALL'),
        handler: () => {
          /*
           * We should pass `true` to force expand all closed rows,
           * if we didn't do that and there are some rows expanded
           * the behavior will be closing the expand rows not
           * expanding the closed ones.
           */
          table.toggleAllRowsExpanded(true);
        },
        disabled: isAllRowsExpanded,
      },
      {
        actionKey: 'close-all-grouped-row',
        mode: 'Add',
        sections: ['toolbar'],
        IconComponent: KeyboardArrowRightIcon,
        tooltip: t('GROUPING_TOOLBAR_ACTIONS.CLOSE_ALL'),
        handler: () => {
          /*
           * We should pass `false` to force close all expanded rows,
           * if we didn't do that and there are some rows closed
           * the behavior will be opening the closed rows not
           * closing the opened ones.
           */
          table.toggleAllRowsExpanded(false);
        },
        disabled: !isSomeRowsExpanded,
      },
    ];
  }, [isAllRowsExpanded, isGrouped, isSomeRowsExpanded, layout, t, table]);
}
